import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, Pagination, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { IoIosArrowForward } from "react-icons/io";
import { useQueryStore } from '../store/useQueryStore';
import TruncatedText from '../Components/TruncatedText';
import { usDateFormatTimeUs } from '../Components/formateDate';
import Skeleton from 'react-loading-skeleton';


const QueryDisplay = () => {
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState('');
  const [field, setField] = useState('');
  const [loading, setLoading] = useState(false);
  const [itemId, setItemId] = useState('');
  const [open, setOpen] = useState(false);

  const { getQuery, query, deleteQuery } = useQueryStore();

  const getQueryData = async () => {
    setLoading(true);
    const res = await getQuery(pageNumber, pageSize, search, field);
    if (res) {
      setTotalPages(res.totalPages || 1);
    }
    setLoading(false);
  };

  const handleDelete = (id) => {
    setItemId(id);
    setOpen(true);
  };

  const handleCancelDelete = () => setOpen(false);

  const handleConfirmDelete = async () => {
    try {
      setOpen(false);
      setLoading(true);
      await deleteQuery(itemId);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const handleChangePagination = (event, value) => {
    setPageNumber(value);
  };

  useEffect(() => {
    getQueryData();
  }, [pageNumber, search, field]);

  return (
    <div>
      <div className="bg-white rounded-lg shadow overflow-hidden">
                        <div className="p-4 border-b flex flex-row justify-between gap-2 ">
      {/* Search and Filter Bar */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
          mb: 2,
        }}
      >
        {/* Dropdown for Field Selection */}
        <select
          value={field}
          onChange={(e) => setField(e.target.value)}
          style={{
            padding: "10px 14px",
            border: "1px solid #d1d5db",
            borderRadius: "6px",
            outline: "none",
            fontSize: "14px",
            backgroundColor: "#fff",
            cursor: "pointer",
          }}
        >
          <option value="">Select The Field</option>
          <option value="productName">Product Name</option>
          <option value="referenceNumber">Reference Number</option>
          <option value="email">Email</option>
          <option value="phoneNumber">Phone Number</option>
          <option value="fullName">Full Name</option>
        </select>

        {/* Search Input */}
        <input
          type="text"
          placeholder={`Search by ${field}`}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            flex: 1,
            padding: "10px 14px",
            border: "1px solid #d1d5db",
            borderRadius: "6px",
            outline: "none",
            fontSize: "14px",
          }}
        />
      </Box>
</div>
      <div className="overflow-x-auto">
        {/* <SectionLoader loading={loading}> */}
        <table className="w-full">
          <thead className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            <tr
              style={{
                backgroundColor: '#fafafa',
                textAlign: 'center',
                fontSize: '12px',
                color: '#6b7280',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
              }}
            >
              <th style={{ border: '1px solid #e5e7eb' }} className="p-2">Product Name</th>
              <th style={{ border: '1px solid #e5e7eb' }} className="p-2">Reference Number</th>
              <th style={{ border: '1px solid #e5e7eb' }} className="p-2">Email</th>
              <th style={{ border: '1px solid #e5e7eb' }} className="p-2">Quantity</th>
              <th style={{ border: '1px solid #e5e7eb' }} className="p-2">Phone Number</th>
              <th style={{ border: '1px solid #e5e7eb' }} className="p-2">Expected Delivery Date</th>
              <th style={{ border: '1px solid #e5e7eb' }} className="p-2">Budget</th>
              <th style={{ border: '1px solid #e5e7eb' }} className="p-2">Sterile</th>
              <th style={{ border: '1px solid #e5e7eb' }} className="p-2">Full Name</th>
              <th style={{ border: '1px solid #e5e7eb' }} className="p-2">Product Specification</th>
              <th
                style={{
                  border: '1px solid #e5e7eb',
                }}
                 className="p-4"
              >
                Actions
              </th>
            </tr>
          </thead>

          <tbody style={{ textAlign: 'center', borderTop: '1px solid #e5e7eb' }}>
            {
              loading ? (
                Array.from({ length: 5 }).map((_, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {Array.from({ length: 11 }).map((_, colIndex) => (
                      <TableCell key={colIndex}>
                        <Skeleton variant="text" animation="wave" />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) :
                (query || []).map((ele, i) => (
                  <tr
                    key={i}
                    style={{
                      transition: 'background-color 0.2s',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#fafafa')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#ffffff')}
                  >
                    <td style={{ border: '1px solid #e5e7eb' }} className="p-2">{ele?.productName}</td>
                    <td style={{ border: '1px solid #e5e7eb' }} className="p-2">{ele?.referenceNumber || "-"}</td>
                    <td style={{ border: '1px solid #e5e7eb' }} className="p-2">{ele?.email}</td>
                    <td style={{ border: '1px solid #e5e7eb' }} className="p-2">{ele?.quantity}</td>
                    <td style={{ border: '1px solid #e5e7eb' }} className="p-2">{ele?.phoneNumber}</td>
                    <td style={{ border: '1px solid #e5e7eb' }} className="p-4">{usDateFormatTimeUs(ele?.expectedDeliveryDate)}</td>
                    <td style={{ border: '1px solid #e5e7eb' }} className="p-4">{ele?.budget}</td>
                    <td style={{ border: '1px solid #e5e7eb' }} className="p-4">{ele?.sterile ? "Sterile" : "Not Sterile"}</td>
                    <td style={{ border: '1px solid #e5e7eb' }} className="p-4">{ele?.fullName}</td>
                    <td style={{ border: '1px solid #e5e7eb', textAlign: 'left', }} className="p-4">
                      {(ele?.specifications || []).map((ele, i) => (
                        <li key={i} style={{display:"flex", alignItems:"center"}}>
                          <IoIosArrowForward style={{marginRight:"5px", fontSize:"12px"}} /> {ele}</li>
                      ))}   
                    </td>
                    <td
                      style={{
                        fontSize: '14px',
                        textAlign: 'center',
                        border: '1px solid #e5e7eb',
                      }} 
                      className="p-4"
                    >
                      <button
                        onClick={() => handleDelete(ele?._id)}
                        style={{
                          border: 'none',
                          background: 'transparent',
                          cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = '#4b5563')}
                        onMouseLeave={(e) => (e.currentTarget.style.color = '#6b7280')}
                        className="text-gray-500 hover:text-red-600"
                      >
                        <i className="fa-solid fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                ))}
          </tbody>
        </table>
        {/* </SectionLoader> */}
      </div>
      {/* Pagination */}
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <Stack spacing={2} style={{ margin: '16px' }}>
          <Pagination
            count={totalPages}
            onChange={handleChangePagination}
            variant="outlined"
            shape="rounded"
            sx={{
              '& .MuiPaginationItem-root': {
                color: 'white',
                borderColor: '#1D4ED8',
                backgroundColor: '#1D4ED8',
              },
              '& .Mui-selected': {
                backgroundColor: '#2563EB !important',
                color: 'white',
              },
              '& .MuiPaginationItem-root:hover': {
                backgroundColor: '#3B82F6',
                color: 'white',
              },
            }}
          />
        </Stack>
      </div>
</div>
      {/* Delete Confirmation Modal */}
      <Modal
        open={open}
        onClose={handleCancelDelete}
        aria-labelledby="confirm-delete-modal"
        aria-describedby="modal-to-confirm-deletion"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '5px',
            boxShadow: 24,
            width: { xs: '80%', md: '500px' },
            textAlign: 'center',
          }}
        >
          <Typography variant="h6" gutterBottom>
            Are you sure you want to delete this Query?
          </Typography>
          <Button
            variant="outlined"
            onClick={handleConfirmDelete}
            style={{
              borderColor: '#1E3A8A',
              color: '#1E3A8A',
              marginRight: '10px',
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            onClick={handleCancelDelete}
            style={{
              borderColor: '#1E3A8A',
              color: '#1E3A8A',
            }}
          >
            No
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default QueryDisplay;
